import React, { useState } from 'react';
import InfoModal from './InfoModal';
import './InfoButton.css';

interface InfoButtonProps {
  title: string;
  content: {
    what: string;
    how: string;
    precedence: string;
  };
}

const InfoButton: React.FC<InfoButtonProps> = ({ title, content }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <span 
        className="info-button"
        onClick={() => setIsModalOpen(true)}
        title={`Learn about ${title}`}
      >
        ℹ️
      </span>
      
      <InfoModal
        title={title}
        content={content}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default InfoButton;